import { render, staticRenderFns } from "./SNPMB-Kategori.vue?vue&type=template&id=26ccf194&"
import script from "./SNPMB-Kategori.vue?vue&type=script&lang=js&"
export * from "./SNPMB-Kategori.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports